var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.2502C13.4599 13.2499 12.6839 13.0414 12 12.6457C11.3162 13.0414 10.5401 13.2499 9.75 13.2502H8.25C7.45882 13.2492 6.68219 13.0374 6 12.6367C5.31784 13.0375 4.54119 13.2493 3.75 13.2502H3C2.20922 13.25 1.43271 13.0395 0.75 12.6405V16.2502C0.75 16.847 0.987053 17.4193 1.40901 17.8412C1.83097 18.2632 2.40326 18.5002 3 18.5002H15C15.5967 18.5002 16.169 18.2632 16.591 17.8412C17.013 17.4193 17.25 16.847 17.25 16.2502V12.6412C16.5671 13.0397 15.7907 13.2499 15 13.2502H14.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.5V5H11.25V0.5H6.75V5H5.25V0.5H1.65L0.018 7.83725L0 8.75C0 9.54565 0.316071 10.3087 0.87868 10.8713C1.44129 11.4339 2.20435 11.75 3 11.75H3.75C4.17742 11.7486 4.59955 11.6554 4.98776 11.4765C5.37597 11.2977 5.72118 11.0375 6 10.7135C6.27882 11.0375 6.62403 11.2977 7.01224 11.4765C7.40045 11.6554 7.82258 11.7486 8.25 11.75H9.75C10.1759 11.7502 10.5969 11.6596 10.9849 11.484C11.3729 11.3085 11.719 11.0522 12 10.7323C12.281 11.0522 12.6271 11.3085 13.0151 11.484C13.4031 11.6596 13.8241 11.7502 14.25 11.75H15C15.7956 11.75 16.5587 11.4339 17.1213 10.8713C17.6839 10.3087 18 9.54565 18 8.75V8L16.35 0.5H12.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProShop);
export default __webpack_public_path__ + "static/media/ProShop.65422e884976008706a707ce53bb0242.svg";
export { ForwardRef as ReactComponent };